export const formatToDollarValue = (amountInCents) => {
  const dollars = (amountInCents / 100).toFixed(2);
  return `$${dollars}`;
};

export const currencyFormat = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount / 100);
};

export const getUserInitials = (user) => {
  if (!user) return '??';
  const { firstname, lastname } = user;
  return `${firstname[0]}${lastname[0]}`.toUpperCase();
};

export const formatMinutesToHours = (minutes) => {
  const minutesAsNumber =
    typeof minutes === 'string' ? parseFloat(minutes) : minutes;
  if (typeof minutesAsNumber !== 'number' || minutesAsNumber < 0) {
    throw new Error('Input must be a non-negative number');
  }
  const hours = minutesAsNumber / 60;
  return hours.toFixed(1);
};
